import {
    FavoriteBorder,
    FavoriteRounded,
    PlayCircleFilledWhiteOutlined,
    ShareRounded,
    YouTube,
} from '@mui/icons-material';
import {
    Badge,
    Box,
    Card,
    CardContent,
    Chip,
    Grid,
    IconButton,
    Modal,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { capitalCase } from 'change-case';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import ShowMoreText from 'react-show-more-text';
import { useToggleLikeMutation } from '../../api/feedSlice';
import { fbEmbed, isYoutube, y2Embed, y2Thmbnail } from '../../utils/embed';
import { handleGuestFeedShare } from '../../utils/sharePost';
import { fbThumbnail } from '../fragments/GuestFeedItem';

export default function KanisaLiveStreamCard({
    interactions,
    church,
    id,
    name,
    venue,
    description,
    stream,
}) {
    const classes = useStyles();
    const [modalOpen, setModalOpen] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const [toggleLike, { isLoading }] = useToggleLikeMutation();

    const onLikeFeed = async () => {
        const { data: likeData } = await toggleLike({ id, type: 'services' });
        if (likeData) enqueueSnackbar(likeData?.message);
    };

    const { liked, likes } = interactions || {};

    return (
        <Grid item xs={12}>
            <Card
                variant="outlined"
                style={{ borderRadius: 8, borderWidth: 2 }}
            >
                <div
                    className={`${classes.media} d-flex align-items-center justify-content-center`}
                    style={{
                        backgroundImage: isYoutube(stream)
                            ? `url(${y2Thmbnail(stream)})`
                            : `url(${fbThumbnail})`,
                        height: ((window.innerWidth - 64) * 9) / 16,
                    }}
                >
                    <IconButton onClick={() => setModalOpen(true)}>
                        {isYoutube(stream) ? (
                            <YouTube
                                color="secondary"
                                sx={{ width: 62, height: 62 }}
                            />
                        ) : (
                            <PlayCircleFilledWhiteOutlined
                                sx={{ color: 'white', width: 62, height: 62 }}
                            />
                        )}
                    </IconButton>
                </div>
                <CardContent sx={{ p: 2 }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <Chip
                            size="small"
                            component="span"
                            className="me-2 text-lowercase"
                            label={venue}
                        />
                        <div>
                            <IconButton
                                size="small"
                                color="primary"
                                disabled={isLoading}
                                sx={{ color: 'secondary.main', mr: 1 }}
                                onClick={onLikeFeed}
                            >
                                <Badge badgeContent={likes} color="secondary">
                                    {liked ? (
                                        <FavoriteRounded />
                                    ) : (
                                        <FavoriteBorder />
                                    )}
                                </Badge>
                            </IconButton>
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() =>
                                    handleGuestFeedShare(
                                        { name, id, stream, church },
                                        'services'
                                    )
                                }
                            >
                                <ShareRounded />
                            </IconButton>
                        </div>
                    </div>
                    <Typography
                        className="fw-bold text-capitalize"
                        sx={{ mt: 1 }}
                    >
                        {capitalCase(name || '')}
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                        <ShowMoreText lines={2} more="more" less="less">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        </ShowMoreText>
                    </Box>
                </CardContent>
            </Card>
            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                <div className={classes.iFrameContainer}>
                    <iframe
                        className={classes.iFrame}
                        src={
                            isYoutube(stream)
                                ? y2Embed(stream)
                                : fbEmbed(stream)
                        }
                        title={name}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </Modal>
        </Grid>
    );
}

const useStyles = makeStyles((theme) => ({
    media: {
        width: '100%',
        height: ((window.innerWidth - 32) * 8) / 16,
        backgroundColor: 'rgba(0,0,0,.5)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'soft-light',
    },
    iFrameContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        bgcolor: 'background.paper',
    },
    iFrame: {
        width: window.innerWidth,
        height: window.innerWidth * (9 / 16),
        backgroundColor: theme.palette.background.default,
    },
}));
